import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processFile = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_FILE, item)
}

export const fetchFiles = (store, params = {}) => {
    return axios.get(`/api/files`, {params})
        .then(res => {
            _.each(res.data.data, item => processFile(store, item))
            return res
        })
}

export const createFile = (store, item) => {
    return axios.post(`/api/files`, item)
        .then(res => {
            processFile(store, res.data.data)
            return res
        })
}

export const createFiles = (store, item) => {
    return axios.post(`/api/files/save`, item)
        .then(res => {
            const files = res.data.data
            files.forEach(file => processFile(store, file))
            return files
        })
}

export const uploadSignature = (store, item) => {
    return axios.patch('/api/users/signature', item)
        .then(res => {
            processUser(res.data.data);
            return res
        })
}

export const updateFile = (store, item) => {
    return axios.patch(`/api/files/${item.id}`, item)
        .then(res => {
            processFile(store, res.data.data)
            return res
        })
}

export const partialUpdateFile = (store, item) => {
    return axios.patch(`/api/files/${item.id}/partial`, item)
        .then(res => {
            processFile(store, res.data.data)
            return res
        })
}

export const createOrUpdateFile = (store, item) => {
    return item.id ?
        updateFile(store, item) :
        createFile(store, item)
}

export const removeFile = (store, item) => {
    return axios.delete(`/api/files/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_FILE, item)
            return res
        })
}
